import { render, staticRenderFns } from "./add_list_detail.vue?vue&type=template&id=dd6cb9b6&"
import script from "./add_list_detail.vue?vue&type=script&lang=js&"
export * from "./add_list_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports